import { getPath, getInitialState } from "../../utils";

const initialState = {
  CityPropertyChangeLog: [],
  GenSettingChangeLog: [],
  nextPage: -1,
  prevPage: -1,
  currentPage: 1,
  Source: "",
  activeChangeLogFilters: {},
  Keys: [],
  keysNextPage: -1,
  keysPrevPage: -1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CITY_PROPERTY_CHANGE_LOG":
      return setCityPropertyChangeLog(state, action);
    case "SET_GEN_SETTING_CHANGE_LOG":
      return setGenSettingChangeLog(state, action);
    case "RESET_STATE_CHANGE_LOG":
      return resetState(state, action);
    case "SET_ACTIVE_FILTERS_CHANGE_LOG":
      return setActiveFiltersChangeLog(state, action);
    case "SET_PROPERTY_KEYS":
      return setPropertyKeys(state, action);
    default:
      return state;
  }
}

const setCityPropertyChangeLog = (state, action) => {
  return {
    ...state,
    CityPropertyChangeLog: getPath(action.payload, "change_logs", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
    Source: getPath(action.payload, "source", -1),
  };
};

const setGenSettingChangeLog = (state, action) => {
  return {
    ...state,
    GenSettingChangeLog: getPath(action.payload, "change_logs", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
    Source: getPath(action.payload, "source", -1),
  };
};

const setActiveFiltersChangeLog = (state, action) => {
  return {
    ...state,
    activeChangeLogFilters: action.payload,
  };
};

const setPropertyKeys = (state, action) => {
  return {
    ...state,
    Keys: action.payload,
    keysNextPage: getPath(action.payload, "pageResponse.nextPage", -1),
    keysPrevPage: getPath(action.payload, "pageResponse.previousPage", -1),
  };
};
const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
